import React from 'react';
import { InputNumber } from 'antd';
import type { InputNumberProps } from 'antd/lib/input-number';
import styled from '@emotion/styled';
import { getCommonInputCssFromProps } from 'components/common/input-components/common-styles';
import omit from 'lodash/omit';

export interface NumberInputProps extends InputNumberProps {
  invalid?: boolean;
}

// withController passes the form's error message as `invalid`, so coerce it to a valid token.
const NumberInput: React.FC<NumberInputProps> = ({ ...props }) => (
  <StyledNumberInput aria-invalid={props.invalid ? true : undefined} {...omit(props, ['hideError'])} />
);

// Unspecced in Figma: extrapolated from Input through the shared antd block, which also drives the
// stepper chrome. `invalid` only styles the field: antd would hand it to the input element.
const StyledNumberInput = styled(InputNumber, { shouldForwardProp: prop => prop !== 'invalid' })<NumberInputProps>`
  ${getCommonInputCssFromProps}

  && .ant-input-number-input::placeholder {
    color: var(--component-field-text-placeholder);
  }

  &&:hover .ant-input-number-input::placeholder {
    color: var(--component-field-text-placeholder-hover);
  }

  &&.ant-input-number-focused .ant-input-number-input::placeholder {
    color: var(--component-field-text-placeholder-active);
  }
`;

export default NumberInput;
